import {
	AdvertisementLabelHandler,
	CloseButtonHelper,
	DebugTransitionHandler,
	DomCleanupHandler,
	DomManipulator,
	ScrollCorrector,
	SlotDecisionTimeoutHandler,
	SlotHeightClippingHandler,
	SlotHiddenHandler,
	SlotSizeResolvedWithPlaceholderHandler,
	SlotStateStickedHandler,
	SlotTransitionHandler,
	StickinessTimeout,
	StickyTlbBlockingHandler,
	StickyTlbBootstrapHandler,
	StickyTlbConfigHandler,
	UapDomManager,
	UapDomReader,
} from '@platforms/shared';
import { context, TemplateAction, TemplateRegistry, universalAdPackage } from '@wikia/ad-engine';
import { Observable } from 'rxjs';
import { registerUcpMobileUapDomElements } from './configs/register-ucp-mobile-uap-dom-elements';
import { CloseToTransitionButtonHandler } from './handlers/close-to-transition-button-handler';

export function registerStickyTlbTemplate(registry: TemplateRegistry): Observable<TemplateAction> {
	let stickyHandlers = [
		SlotSizeResolvedWithPlaceholderHandler,
		SlotDecisionTimeoutHandler,
		CloseToTransitionButtonHandler,
		DomCleanupHandler,
		SlotStateStickedHandler,
	];

	// Remove 'SlotDecisionTimeoutHandler' to prevent top leaderboard from disappearing
	// when sticky leaderboard is active
	if (!context.get('options.disableStickyTopLeaderboard')) {
		stickyHandlers = stickyHandlers.filter((handler) => handler !== SlotDecisionTimeoutHandler);
	}

	return registry.register(
		'stickyTlb',
		{
			blocking: [StickyTlbBlockingHandler],
			initial: [
				StickyTlbBootstrapHandler,
				StickyTlbConfigHandler,
				AdvertisementLabelHandler,
				DebugTransitionHandler,
			],
			sticky: stickyHandlers,
			transition: [
				SlotSizeResolvedWithPlaceholderHandler,
				SlotTransitionHandler,
				DomCleanupHandler,
				SlotStateStickedHandler,
			],
			resolved: [
				SlotSizeResolvedWithPlaceholderHandler,
				SlotHeightClippingHandler,
				DomCleanupHandler,
			],
			hidden: [SlotHiddenHandler, DomCleanupHandler],
		},
		'blocking',
		[
			DomManipulator,
			UapDomManager,
			UapDomReader,
			ScrollCorrector,
			CloseButtonHelper,
			StickinessTimeout.provide(universalAdPackage.TLB_UNSTICK_DELAY),
			registerUcpMobileUapDomElements(),
		],
	);
}
